import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { SurveyResponseFilter, SurveyResponseFiltersProps } from './props';
import { asyncGetSurveys } from '../../../../../services/survey.service';

export const useSurveyResponseFilters = (
    onFilter: SurveyResponseFiltersProps['onFilter']
) => {
    const [surveys, setSurveys] = useState<{ id: string; name: string }[]>([
        { id: '', name: 'Todas' },
    ]);

    const formik = useFormik<SurveyResponseFilter>({
        initialValues: {
            status: '',
            surveyId: '',
            surveyCode: '',
            documentNumber: '',
            customerName: '',
            associatedService: '',
            startDate: '',
            endDate: '',
        },
        onSubmit: (values) => {
            onFilter(values);
        },
    });

    useEffect(() => {
        // Cargar encuestas activas
        asyncGetSurveys({ limit: 1000, page: 0 }).then((res) => {
            const surveyOptions = res.items.map((survey: any) => ({
                id: survey.id,
                name: `${survey.code} - ${survey.title}`,
            }));
            setSurveys([{ id: '', name: 'Todas' }, ...surveyOptions]);
        });
    }, []);

    return {
        formik,
        surveys,
    };
};
